<script>
import Layout from '@/Shared/Layout'
export default {
  layout: Layout,
}
</script>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { Carousel, Slide, Pagination } from 'vue3-carousel'
import { Head } from '@inertiajs/inertia-vue3'
import stripslashes, { replaceS3path, formatDate } from '@/Shared/helper.js'
import Sidebar from '@/Shared/Sidebar/SidebarBannersNews/'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  newsInfo: Array,
  slides: Array,
  pref: Object,
})

const keyvisualRef = ref()

const cleanup = function (str) {
  const t = replaceS3path(stripslashes(str))
  return t
}

const generateBlocks = () => {
  let t = cleanup(props.newsInfo[0].newsTxt)
  let result = t.split('[Slides')
  let slide_element = []
  let maintxt = []
  result.forEach((e) => {
    let f
    let c
    if (e.includes('label="')) {
      f = e.split(']')
      c = f[0].replaceAll('"', '').replaceAll(' ', '').replaceAll('label=', '')
      slide_element.push(c)
      maintxt.push(f[1])
    } else {
      maintxt.push(e)
    }
  })
  return maintxt
}

const generateSlideLoop = ($slidedata) => {
  let $slide_images = []
  for (let $v = 1; $v <= 10; $v++) {
    let $myarray = {}
    if ($slidedata['slideImgUrl' + $v]) {
      $myarray['img'] = $slidedata['slideImgUrl' + $v]
      $myarray['txt'] = $slidedata['slideTxt' + $v]
      $myarray['url'] = $slidedata['slideUrl' + $v]
      $slide_images.push($myarray)
    }
  }
  return $slide_images
}

const setKeyvisual = () => {
  const keyvisual = document.querySelector('.block img')
  const parent = keyvisual.parentElement
  keyvisualRef.value.appendChild(keyvisual)
  if (parent.childNodes.length === 0) parent.remove()
}

const removeUnnecessaryTitle = () => {
  const title = document.querySelector('.block p:first-child')
  if (!title) return
  if (title.textContent.slice(0, 1) === '【') title.remove()
}

onMounted(() => {
  usePref(props.pref)
  setKeyvisual()
  removeUnnecessaryTitle()
})

onUnmounted(() => {})
</script>

<template>
  <div class="news-detail">
    <Head :title="props.newsInfo[0].newsTitle" />

    <div class="detail-container">
      <Breadcrumbs category="news" :title="props.newsInfo[0].newsTitle" />

      <div class="detail-contents">
        <div class="main">
          <div ref="keyvisualRef" class="keyvisual" />

          <div class="main-contents">
            <div class="date">{{ formatDate(props.newsInfo[0].newsPubdate) }}</div>
            <h1 class="title">{{ props.newsInfo[0].newsTitle }}</h1>
            <div v-for="(block, index) in generateBlocks()" :key="index">
              <div class="block" v-html="block" />

              <template v-if="slides[index]">
                <carousel :wrap-around="true" :items-to-show="1" :transition="400" class="news-detail-slide mb-5">
                  <slide v-for="slide in generateSlideLoop(slides[index])" :key="slide.img">
                    <a class="inner" :href="slide.url" target="_blank">
                      <div class="img"><img :src="replaceS3path(slide.img)" :alt="slide.txt" /></div>
                      <div class="btn">
                        <img src="https://img.aandf.co.jp/aandfcojp/img/news/zoom_icon.png" alt="open" />
                        <div class="txt"><div v-html="slide.txt" /></div>
                      </div>
                    </a>
                  </slide>
                  <template #addons><Pagination /></template>
                </carousel>
              </template>
            </div>
          </div>
        </div>
        <Sidebar category="category" :slug="props.newsInfo[0].newsCategory" />
      </div>
    </div>
  </div>
</template>
